import moment from 'moment'

export const formatUTCDate = (date: Date) => {
  if (Number.isNaN(date.getTime())) return 'Invalid Date'

  return date.toISOString().slice(0, 10)
}

export const formatUTCTime = (date: Date) => {
  if (Number.isNaN(date.getTime())) return 'Invalid Time'

  return date.toISOString()
}

export const formatISODate = (date: Date) => {
  return `${formatUTCTime(date)} (${moment(date).fromNow()})`
}
